module.exports = __webpack_public_path__ + "static/IMG_1179-38f95ec6cd603e336dfb64ef57397ddf.jpg";